'use client'

import { useEffect } from 'react'
import { reloadOnChunkLoadError } from '@/util/chunk-load-error'

// global-error replaces the root layout when an error is thrown there, so it must
// render its own <html> and <body>.
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // Recover from Next.js stale-chunk failures after a deploy by reloading the
    // page to fetch the current build (guarded against reload loops).
    reloadOnChunkLoadError(error)
  }, [error])

  return (
    <html lang="en" className="h-full">
      <body className="h-full">
        <p>Something went wrong!</p>
        <button onClick={() => reset()}>Reset error boundary</button>
      </body>
    </html>
  )
}
